// Whether the desktop sidebar is collapsed to an icon rail (tracker row 67 —
// Rize: "Ability to have the left sidebar collapse when not needed. Gives more
// breathing room to what you're working on").
//
// Pure storage helpers, deliberately separate from the component: the read has
// to survive a browser that refuses localStorage (private windows, blocked site
// data) without taking the navigation down with it, and that is exactly the
// kind of thing a unit test should own rather than a screenshot.
//
// The COLLAPSED state is its own key, not folded into the existing
// `rize:sidebar:collapsed-groups` array. They answer different questions — one
// is "how wide is the sidebar", the other "which groups are open" — and the
// group set is shared BETWEEN the two widths on purpose: a rail's group
// chevrons toggle the same set the full sidebar does, so opening Deals in the
// rail leaves it open when you widen it again.

export const SIDEBAR_COLLAPSED_KEY = 'rize:sidebar:collapsed'

/**
 * Read the saved width. Defaults to EXPANDED — a first-time user must see the
 * navigation with words on it, or the product looks like a strip of glyphs.
 */
export function loadSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true'
  } catch {
    // Storage unavailable — render expanded rather than throwing on first paint.
    return false
  }
}

/** Persist the width. A storage failure must never break the toggle itself. */
export function saveSidebarCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? 'true' : 'false')
  } catch {
    /* storage unavailable — the choice still applies for this session */
  }
}
